function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg13N(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.84,
    height: 33.274,
    viewBox: "0 0 30.84 33.274",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "13n"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184503"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184502"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184498"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14447",
    d: "M268.217 191.183a4.444 4.444 0 0 0-4.388-3.437 4.567 4.567 0 0 0-2.794.945 7.952 7.952 0 0 0-7.1-4.255 7.822 7.822 0 0 0-7.853 6.65 5.282 5.282 0 0 0-4.235 5.085 5.335 5.335 0 0 0 5.417 5.215h19.383a5.335 5.335 0 0 0 5.417-5.215 5.263 5.263 0 0 0-3.847-4.988z",
    transform: "translate(-241.843 -176.33)",
    style: {
      fill: "#d32f2f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184623"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14526",
    d: "M3.469 10.138A5.168 5.168 0 0 1 0 8.8h.334A5.518 5.518 0 0 0 4.767 0a5.152 5.152 0 0 1-1.3 10.136z",
    transform: "rotate(105.01 14.333 13.245)",
    style: {
      fill: "#283593"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14527",
    d: "M3.329.694A.147.147 0 0 0 3.43.62L3.772 0l.34.62a.147.147 0 0 0 .1.074l.694.133-.483.516a.141.141 0 0 0-.039.119l.088.7-.639-.3a.141.141 0 0 0-.125 0l-.641.3.088-.7a.145.145 0 0 0-.037-.119L2.635.827zM.293 3.573l.057-.454A.145.145 0 0 0 .311 3L0 2.668l.448-.082a.152.152 0 0 0 .1-.074l.219-.391.221.391a.145.145 0 0 0 .1.074l.448.084L1.22 3a.151.151 0 0 0-.039.119l.057.453-.412-.2a.151.151 0 0 0-.125 0zm3.8 1.214a.147.147 0 0 0-.037.119l.057.452-.412-.2a.145.145 0 0 0-.063-.014.139.139 0 0 0-.063.014l-.412.2.057-.452a.149.149 0 0 0-.039-.119l-.313-.332.448-.086a.149.149 0 0 0 .1-.072l.221-.4.219.4a.149.149 0 0 0 .1.072l.448.086z",
    transform: "rotate(105.01 14.603 12.306)",
    style: {
      fill: "#283593"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14532",
    d: "m81.443 398.731-.954.256-1.23-.71 1.23-.71.954.256a.188.188 0 0 0 .1-.363l-.593-.159.418-.241a.188.188 0 0 0-.19-.325l-.416.24.158-.591a.188.188 0 0 0-.363-.1l-.256.957-1.23.71v-1.42l.7-.7a.188.188 0 0 0-.266-.266l-.433.433v-.482a.188.188 0 0 0-.376 0V396l-.433-.433a.188.188 0 0 0-.266.266l.7.7v1.42l-1.23-.71-.256-.957a.188.188 0 0 0-.363.1l.158.591-.416-.24a.188.188 0 0 0-.19.325l.418.241-.593.159a.188.188 0 0 0 .1.363l.954-.256 1.23.71-1.23.71-.954-.256a.188.188 0 0 0-.1.363l.593.159-.418.241a.188.188 0 0 0 .19.325l.416-.24-.158.591a.188.188 0 0 0 .363.1l.256-.957 1.23-.71v1.42l-.7.7a.188.188 0 0 0 .266.266l.433-.433v.482a.188.188 0 0 0 .376 0v-.482l.433.433a.188.188 0 0 0 .266-.266l-.7-.7V398.6l1.23.71.256.957a.188.188 0 0 0 .363-.1l-.158-.591.416.24a.188.188 0 0 0 .19-.325l-.418-.241.593-.159a.188.188 0 0 0-.1-.36z",
    transform: "translate(-68.522 -368.195)",
    style: {
      stroke: "#283593",
      strokeWidth: ".5px",
      fill: "#283593"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14533",
    d: "m113.31 398.731-.954.256-1.23-.71 1.23-.71.954.256a.188.188 0 0 0 .1-.363l-.593-.159.418-.241a.188.188 0 0 0-.19-.325l-.416.24.158-.591a.188.188 0 0 0-.363-.1l-.256.957-1.23.71v-1.42l.7-.7a.188.188 0 0 0-.266-.266l-.433.433v-.482a.188.188 0 0 0-.376 0V396l-.433-.433a.188.188 0 0 0-.266.266l.7.7v1.42l-1.23-.71-.256-.957a.188.188 0 0 0-.363.1l.158.591-.416-.24a.188.188 0 0 0-.19.325l.418.241-.593.159a.188.188 0 0 0 .1.363l.954-.256 1.23.71-1.23.71-.954-.256a.188.188 0 0 0-.1.363l.593.159-.418.241a.188.188 0 0 0 .19.325l.416-.24-.158.591a.188.188 0 0 0 .363.1l.256-.957 1.23-.71v1.42l-.7.7a.188.188 0 0 0 .266.266l.433-.433v.482a.188.188 0 0 0 .376 0v-.482l.433.433a.188.188 0 0 0 .266-.266l-.7-.7V398.6l1.23.71.256.957a.188.188 0 0 0 .363-.1l-.158-.591.416.24a.188.188 0 0 0 .19-.325l-.418-.241.593-.159a.188.188 0 0 0-.1-.36z",
    transform: "translate(-91.888 -368.195)",
    style: {
      stroke: "#283593",
      strokeWidth: ".5px",
      fill: "#283593"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184501"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184499"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14448",
    d: "M266.03 191.266a6.281 6.281 0 0 1 5.088-2.716.376.376 0 0 0 0-.752 7.077 7.077 0 0 0-5.738 3.088c-.279.4.373.774.65.38z",
    transform: "translate(-259.051 -178.795)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184500"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14449",
    d: "M246.365 218.167a4.088 4.088 0 0 1 1.917-3.406c.407-.26.03-.912-.38-.65a4.866 4.866 0 0 0-2.289 4.055.376.376 0 0 0 .752 0z",
    transform: "translate(-244.606 -198.045)",
    style: {
      fill: "#fff"
    }
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg13N);
export default __webpack_public_path__ + "static/media/13N.9deae1b7c87ed3bdfee79daa20d1556e.svg";
export { ForwardRef as ReactComponent };